import { AppModule } from 'app/module';
import { loadScript } from 'util/loadScript';
import { CONSENT_GROUPS, hasConsent } from 'util/consent';
import { ENDPOINT_USER_LOGIN } from 'app/endpoints';
import Template from './template.hbs';
import './styles.scss';

const SCRIPT_ID = 'googleTagServices';
const SALARY_CONTENT_AD_ID = 138314721585;
let slot = false;

export class ContentAd extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    ready() {
        if (hasConsent(CONSENT_GROUPS.marketing)) {
            this.load();
        }
    }

    load() {
        loadScript('//www.googletagservices.com/tag/js/gpt.js', SCRIPT_ID);
        window.googleTagReady = () => {
            this.afterRender();
        };
    }

    domBindings() {
        return {
            container: '.m-contentAd__container',
        };
    }

    getPropsFromDom() {
        if (this.dom.container) {
            return {
                active: true,
                id: this.dom.container.id,
                adUnitPath: this.dom.container.getAttribute('data-adunitpath'),
                targeting: {
                    keyword: this.dom.container.getAttribute('data-keyword'),
                    location: this.dom.container.getAttribute('data-location'),
                    jobfield: this.dom.container.getAttribute('data-jobfield'),
                    state: this.dom.container.getAttribute('data-state'),
                    employmenttype: this.dom.container.getAttribute('data-employmenttype'),
                    joblevel: this.dom.container.getAttribute('data-joblevel'),
                    isloggedin: (this.dom.container.getAttribute('data-isloggedin') === 'true'),
                    hasprofile: this.dom.container.getAttribute('data-hasprofile'),
                    hasjobalarm: (this.dom.container.getAttribute('data-hasjobalarm') === 'true'),
                },
            };
        }
        return {};
    }

    afterRender() {
        if (window.googletag && googletag.apiReady) {
            this.destroyAd();

            if (this.props.active) {
                this.renderAd();
            }
        }
    }

    renderAd() {
        googletag.cmd.push(() => {
            slot = googletag
                .defineSlot(this.props.adUnitPath, 'fluid', this.props.id)
                .addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.enableServices();
            googletag.pubads().addEventListener('slotRenderEnded', (event) => {
                const salaryAd = event.creativeId === SALARY_CONTENT_AD_ID;
                this.handleSalaryAd(salaryAd);
            });
            googletag.display(this.props.id);
            this.setTargeting();
            googletag.pubads().refresh();
        });
    }

    setTargeting() {
        googletag.cmd.push(() => {
            const targetingKeys = Object.keys(this.props.targeting);
            targetingKeys.forEach((targetingKey) => {
                const targetingValue = this.props.targeting[targetingKey];
                if (targetingKeys && targetingValue) {
                    slot.setTargeting(targetingKey, targetingValue);
                }
            });
        });
    }

    destroyAd() {
        googletag?.cmd?.push(() => googletag.destroySlots([slot]));
        slot = false;
    }

    handleSalaryAd(salaryAd) {
        const contentAd = this.dom.el.querySelector('.m-contentAd');
        this.removeOverlay(contentAd);
        if (salaryAd) {
            this.addOverlay(contentAd);
        }
    }

    addOverlay(contentAd) {
        if (contentAd) contentAd.classList.add('m-contentAd--loginModalTrigger');
        this.dom.el.classList.add('m-jobsList__contentAd--loginModalTrigger');
        this.salaryAdClickEvent = this.onSalaryAdClick.bind(this);
        this.dom.el.addEventListener('click', this.salaryAdClickEvent);
    }

    removeOverlay(contentAd) {
        this.dom.el.removeEventListener('click', this.salaryAdClickEvent);
        if (contentAd) contentAd.classList.remove('m-contentAd--loginModalTrigger');
        this.dom.el.classList.remove('m-jobsList__contentAd--loginModalTrigger');
    }

    onSalaryAdClick() {
        this.events.emit('openLoginModal', `${ENDPOINT_USER_LOGIN}?redirectUrl=${window.location.href}`, true);
    }
}
